import { render, staticRenderFns } from "./characterAnime.vue?vue&type=template&id=3cb5cfcc&scoped=true"
import script from "./characterAnime.vue?vue&type=script&lang=js"
export * from "./characterAnime.vue?vue&type=script&lang=js"
import style0 from "./characterAnime.vue?vue&type=style&index=0&id=3cb5cfcc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5cfcc",
  null
  
)

export default component.exports